import { LandingHomeOfficeComponent } from './landing-home-office.component';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    LandingHomeOfficeComponent
  ],
  imports: [
    RouterModule,
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LocalizeRouterModule
  ],
  exports: [
    LandingHomeOfficeComponent
  ]
})

export class LandingHomeOfficeModule { }
